module.exports = __webpack_public_path__ + "img/media_fb.6b85699f.svg";